export default __webpack_public_path__ + "static/media/girl2.67aa873d.svg";